export const online = "https://dojoformusic.com";
export const url = "https://dojoformusic.com";
//  "http://dojoformusic.com";
// http://dojoformusic.com
// http://localhost:5000
